import * as T from 'three';
import {layout as L} from './layout.js';

// TextureLoader rejects failures; runtime never displays an untextured floor silently.
export async function loadFloorTexture(loader=new T.TextureLoader()){
 const texture=await loader.loadAsync('/assets/floor/WoodFloor051_1K-JPG_Color.jpg');
 if(!texture?.isTexture)throw new Error('Invalid interior floor texture');
 texture.colorSpace=T.SRGBColorSpace;texture.wrapS=texture.wrapT=T.RepeatWrapping;
 texture.repeat.set((L.house.width-L.house.thickness)/1.8,(L.house.depth-L.house.thickness)/1.8);
 return texture;
}

export function createInteriorFinishes(floorTexture){
 if(!floorTexture?.isTexture)throw new Error('Interior floor texture is required');
 const h=L.house,d=L.door,root=new T.Group();root.name='interior-finishes';
 const width=h.width-h.thickness-.03,depth=h.depth-h.thickness-.03;
 const floor=new T.Mesh(new T.PlaneGeometry(width,depth),new T.MeshLambertMaterial({map:floorTexture,color:0xffffff}));
 floor.name='finished-floor';floor.rotation.x=-Math.PI/2;floor.position.set(h.x,.002,h.z);root.add(floor);
 const ceiling=new T.Mesh(new T.PlaneGeometry(width,depth),new T.MeshLambertMaterial({color:'#eee9de'}));
 ceiling.name='finished-ceiling';ceiling.rotation.x=Math.PI/2;ceiling.position.set(h.x,h.height-.081,h.z);root.add(ceiling);
 const trim=new T.MeshLambertMaterial({color:'#eee9de'});
 function board(w,depth,x,z){const o=new T.Mesh(new T.BoxGeometry(w,.10,depth),trim);o.position.set(x,.05,z);root.add(o);}
 // Low skirting is flush against the internal shell, interrupted at the doorway.
 const east=h.maxX-h.thickness/2-.012,west=h.minX+h.thickness/2+.012,north=h.minZ+h.thickness/2+.012,south=h.maxZ-h.thickness/2-.012;
 board(.024,h.depth-h.thickness,west,h.z);board(.024,h.depth-h.thickness,east,h.z);
 board(width,.024,h.x,north);
 for(const [a,b] of [[h.minX+h.thickness/2,d.minX],[d.maxX,h.maxX-h.thickness/2]])board(b-a,.024,(a+b)/2,south);
 return root;
}
